import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { CONTEXT_MESSAGES } from '@constants/leadCaptureConstants';
import { ROUTES } from '@constants/routes';
import { useContactFabVisibility } from '@hooks/useContactFabVisibility/useContactFabVisibility';
import { useSessionContext } from '@contexts/SessionContext';
import { useCustomer } from '@contexts/CustomerContext';
import { useShoppingCart } from '@hooks/useShoppingCart/useShoppingCart';
import { useProductOffersStore } from '@store/productOffersStore/productOffersStore';
import { closeCpqApp } from '@utils/sessionUtils';
import ContactFab from '@shared/components/buttons/ContactFab';
import LeadCaptureDialog from '@components/modals/LeadCaptureDialog/LeadCaptureDialog';

const ContactFloatingAction = () => {
  const [open, setOpen] = useState(false);
  const theme = useTheme();
  const { pathname } = useLocation();
  const isVisible = useContactFabVisibility();
  const { sessionId } = useSessionContext();
  const { branding } = useCustomer();
  const { cart } = useShoppingCart(sessionId ?? '');
  const footerCheckoutError = useProductOffersStore((s) => s.footerCheckoutError);

  if (!isVisible) return null;

  const handleExitApp = () => {
    setOpen(false);
    closeCpqApp(undefined, branding.homepageUrl);
  };

  const { novusFooterHeight, novusFabOffset, novusFabBannerOffset } = theme.novus;
  const hasCartFooter = pathname === ROUTES.RESIDENTIAL;
  const footerHeightPx = hasCartFooter ? parseInt(novusFooterHeight, 10) : 0;
  const bannerHeightPx = hasCartFooter && footerCheckoutError ? novusFabBannerOffset : 0;
  const bottomOffsetPx = footerHeightPx + bannerHeightPx + novusFabOffset;

  return (
    <>
      <ContactFab onClick={() => setOpen(true)} bottomOffsetPx={bottomOffsetPx} />
      <LeadCaptureDialog
        open={open}
        onClose={() => setOpen(false)}
        onSuccess={handleExitApp}
        title="Let's Talk!"
        contextPayload={{ cartId: cart?.shoppingCartId, callbackIndicator: true }}
        contextMessageOverride={CONTEXT_MESSAGES.CONTACT_US}
        successActionLabel="RETURN TO HOMEPAGE"
        onSuccessAction={handleExitApp}
      />
    </>
  );
};

export default ContactFloatingAction;
